import { Dialog } from "@hubertai/hubert-component-library";
import { CheckCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button, Heading, Text } from "../elements";

const InterviewCompletedModal = () => {
    const { t } = useTranslation();

    return (
        <Dialog.Root defaultOpen>
            <Dialog.Content className="interview-completed-modal">
                <div className="head-section">
                    <div className="icon-wrapper">
                        <CheckCircle size={32} />
                    </div>
                    <div>
                        <Heading level="h3">{t("Dashboard.InterviewCompletedModal.Title")}</Heading>
                        <Heading level="h4" light>
                            {t("Dashboard.InterviewCompletedModal.Subtitle")}
                        </Heading>
                    </div>
                </div>
                <div className="body-section">
                    <Text block>{t("Dashboard.InterviewCompletedModal.Description")}</Text>
                </div>
                <div className="button-section">
                    <Dialog.Close>
                        <Button ariaLabel={t("Dashboard.InterviewCompletedModal.ButtonText_Continue")}>
                            {t("Dashboard.InterviewCompletedModal.ButtonText_Continue")}
                        </Button>
                    </Dialog.Close>
                </div>
            </Dialog.Content>
        </Dialog.Root>
    );
};

export default InterviewCompletedModal;
